// Phase 20.1 — reCAPTCHA v3 client helper.
//
// No-ops (resolves null) when REACT_APP_RECAPTCHA_SITE_KEY is unset, so the
// app works unchanged until keys are configured (Phase 19.3). When set, the
// Google script is lazy-loaded once and getCaptchaToken() returns a token to
// include as `captchaToken` in auth POST bodies.

const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '';

let scriptLoading: Promise<void> | null = null;

function loadScript(): Promise<void> {
  if (!scriptLoading) {
    scriptLoading = new Promise((resolve, reject) => {
      if ((window as any).grecaptcha) return resolve();
      const s = document.createElement('script');
      s.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(SITE_KEY)}`;
      s.async = true;
      s.onload = () => resolve();
      s.onerror = () => reject(new Error('Failed to load reCAPTCHA'));
      document.head.appendChild(s);
    });
  }
  return scriptLoading;
}

/**
 * Get a reCAPTCHA v3 token for the given action, or null when CAPTCHA is not
 * configured / unavailable (backend fails open in that case too).
 */
export async function getCaptchaToken(action: string): Promise<string | null> {
  if (!SITE_KEY) return null;
  try {
    await loadScript();
    const grecaptcha = (window as any).grecaptcha;
    await new Promise<void>((resolve) => grecaptcha.ready(resolve));
    return await grecaptcha.execute(SITE_KEY, { action });
  } catch {
    return null;
  }
}
